import { OrganizationId } from "./core/backend/controllers";

export const CANTONS_NODEID = "org_staatskanzlei" as OrganizationId;
export const COMMUNES_NODEID = "org_kommunal" as OrganizationId;
